
export const FilterIconSx = { width: '43px', height: '43px', cursor: 'pointer' };

export const approvalListContainerSx = { p: 3 };

export const approvalListHeaderSx = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: 3,
};

export const approvalListTitleSx = { fontWeight: 700 };

export const approvalListActionsSx = { display: 'flex', alignItems: 'center', gap: 2 };

export const approvalListSearchSx = {
  width: 280,
  '& .MuiOutlinedInput-root': { borderRadius: '8px' },
};

export const approvalListCreateBtnSx = {
  borderRadius: '8px',
  fontWeight: 600,
  textTransform: 'none',
  backgroundColor: '#1F2937',
  '&:hover': { backgroundColor: '#111827' },
  px: 2.5,
};

export const filterModalContainerSx = {
  width: 480,
  bgcolor: 'background.paper',
  borderRadius: 4,
  mx: 'auto',
  mt: '10%',
  boxShadow: 24,
  outline: 'none',
  overflow: 'hidden',
};

export const approvalTableContainerSx = {
  borderRadius: '12px',
  boxShadow: 'none'
};

export const approvalTableHeadRowSx = { backgroundColor: '#FAFAFA' };

export const approvalTableHeaderCellSx = {
  fontWeight: 400,
  fontSize: '0.875rem', // 14px
  fontFamily: 'Nunito',
  color: '#505050',
  borderBottom: '1px solid #E5E7EB',
  py: 1.5,
  whiteSpace: 'nowrap' as const,
};

export const approvalTableBodyCellSx = {
  fontSize: '0.8125rem', // 13px
  fontFamily: 'Nunito',
  fontWeight: 600,
  color: '#232323',
  borderBottom: '1px solid #F3F4F6',
  py: 1.8,
};

export const approvalTableSwitchSx = {
  width: '2.625rem',   // 42px
  height: '1.5rem',    // 24px
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '0.1875rem', // 3px
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(1.125rem)', // 18px
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#47B35F',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '1.125rem',  // 18px
    height: '1.125rem', // 18px
  },
  '& .MuiSwitch-track': {
    borderRadius: '0.75rem', // 12px
    backgroundColor: '#C4C4C4',
    opacity: 1,
  },
};

export const APPROVAL_TABLE_COL_WIDTHS = {
  ruleName: 220,
  documentType: 180,
  clinic: 130,
  conditions: 170,
  approvalFlow: 300,
  activeToggle: 120,
  actions: 60,
};

export const APPROVAL_TABLE_SKELETON_WIDTHS = [160, 110, 100, 130, 200, 60, 40];

// ─── ApprovalFlowCell ────────────────────────────────────────────────────────
export const approvalFlowCellContainerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap' as const,
};

export const approvalFlowCardSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'flex-start',
  backgroundColor: '#FAFAFA',
  border: '1px solid #CFD1D4',
  borderRadius: '0.5rem',
  px: 1.5,
  py: 0.8,
  minWidth: '7.5rem',
};

export const approvalFlowRoleSx = {
  fontSize: '0.8125rem', // 13px
  fontWeight: 500,
  color: '#232323',
  fontFamily: 'Nunito',
  lineHeight: 1.3,
};

export const approvalFlowMetaBoxSx = { display: 'flex', gap: 0.5, mt: 0.3 };

export const approvalFlowLevelSx = { fontSize: '0.6875rem', color: '#505050', mr: 0.5 }; // 11px

export const approvalFlowLevelLineSx = { fontSize: '0.6875rem', color: '#CFD1D4'}; // 11px

export const approvalFlowMandatorySx = { fontSize: '0.6875rem', color: '#505050', ml: 0.5 }; // 11px

export const approvalFlowArrowSx = { color: '#232323', fontSize: '1rem', mx: 0.5 };

export const approvalFlowOverflowBadgeSx = {
  fontSize: '0.6875rem',
  fontWeight: 600,
  color: '#6B7280',
  backgroundColor: '#F3F4F6',
  border: '1px solid #E5E7EB',
  borderRadius: '1rem',
  px: 1,
  py: 0.3,
  whiteSpace: 'nowrap' as const,
};

export const approvalFlowInfoBtnSx = {
  ml: 0.5,
  color: '#6B7280',
  padding: '0.25rem',
  '&:hover': { backgroundColor: 'rgba(107,114,128,0.1)' },
};

export const approvalFlowPopoverCardSx = {
  display: 'flex',
  flexDirection: 'column' as const,
  alignItems: 'flex-start',
  backgroundColor: '#FAFAFA',
  border: '1px solid #CFD1D4',
  borderRadius: '0.5rem',
  px: 1.5,
  py: 0.8,
  minWidth: '7.5rem',
};
